import React from 'react';
import { Link } from 'react-router-dom';
import { Award, Sparkles, ChevronRight } from 'lucide-react';
import { WAVE_WINS } from './homeConstants';
import { useDemoProfile } from '../../hooks/useDemoProfile';

export default function WaveWinsColumn() {
  const { profile, isDemo } = useDemoProfile();
  // Demo brands swap to their brand-specific wins so investors don't see
  // wellness-themed copy inside an auto or QSR brand.
  const wins = (isDemo && profile?.home_wins?.length) ? profile.home_wins : WAVE_WINS;
  return (
    <div className="rounded-2xl p-5 lg:p-6" style={{ background: '#242730', border: '1px solid #2E3240' }}
         data-testid="wave-wins-column">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-base font-black text-white flex items-center gap-2">
          <Award className="h-4 w-4 text-[#FF4D94]" /> Recent Wave Wins
        </h2>
        <span className="text-[8px] text-gray-600 uppercase tracking-widest">Powered by Wave Technology™</span>
      </div>
      <div className="space-y-2.5" data-testid="wave-wins">
        {wins.map((win) => (
          <div key={win.creator} className="rounded-xl p-3 flex items-start gap-3 hover:border-[#00D4FF]/25 transition-all group"
               style={{ background: '#181A20', border: '1px solid #2E3240' }}>
            <div className="w-8 h-8 rounded-lg flex-shrink-0 flex items-center justify-center"
                 style={{ background: 'linear-gradient(135deg, #00D4FF22, #FF4D9422)', border: '1px solid #2E3240' }}>
              <Sparkles className="h-4 w-4 text-[#00D4FF] group-hover:scale-110 transition-transform" />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-[11px] text-white leading-snug mb-1.5">
                <span className="font-black text-[#00D4FF]">{win.creator}</span> {win.event}
              </p>
              <div className="flex items-center justify-between">
                <span className="text-[9px] px-2 py-0.5 rounded-full bg-green-500/10 text-green-400 border border-green-500/20 font-bold">
                  {win.metric}
                </span>
                <Link to="/campaigns" className="text-[9px] text-[#00D4FF] hover:underline font-bold flex items-center gap-0.5">
                  View Pulse <ChevronRight className="h-3 w-3" />
                </Link>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
